<template>
  <a-modal
    width="800px"
    title="确认计算结果"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      根据已填写信息，
      <span v-if="calculationAbnormal.length" style="color: red;">部分结果异常或有误，建议返回检查</span>
      <span v-else>计算结果如下</span>:
    </div>
    <br>
    <h3>阶段/全程生产成绩</h3>
    <div class="result">
      <a-row type="flex"  align="middle" :gutter="24" >
        <a-col :span="6" >
          <span class="title">总成活率（%）</span>
          <a-icon v-if="isAbnormal('totalSurvivalRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('totalSurvivalRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.totalSurvivalRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span >吃食鱼成活率（%）</span>
          <a-icon v-if="isAbnormal('eatFoodSurvivalRate')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('eatFoodSurvivalRate') ? 'abnormalBox' : 'box'">
            {{calculationResult.eatFoodSurvivalRate?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>饵料系数</span>
          <a-icon v-if="isAbnormal('baitFactor')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('baitFactor') ? 'abnormalBox' : 'box'">
            {{calculationResult.baitFactor?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>总产量（斤/亩）</span>
          <a-icon v-if="isAbnormal('totalOutput')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('totalOutput') ? 'abnormalBox' : 'box'">
            {{calculationResult.totalOutput?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>吃食鱼产量（斤/亩）</span>
          <a-icon v-if="isAbnormal('eatFoodOutput')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('eatFoodOutput') ? 'abnormalBox' : 'box'">
            {{calculationResult.eatFoodOutput?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>滤食鱼产量（斤/亩）</span>
          <a-icon v-if="isAbnormal('filterFoodOutput')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('filterFoodOutput') ? 'abnormalBox' : 'box'">
            {{calculationResult.filterFoodOutput?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>饲料产量（斤/吨）</span>
          <a-icon v-if="isAbnormal('feedOutput')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('feedOutput') ? 'abnormalBox' : 'box'">
            {{calculationResult.feedOutput?.toFixed(2) || '-'}}
          </div>
        </a-col>
        <a-col :span="6" >
          <span>造肉成本（元/斤）</span>
          <a-icon v-if="isAbnormal('meatProductCost')" type="exclamation-circle" theme="filled"/>
        </a-col>
        <a-col :span="6" >
          <div :class="isAbnormal('meatProductCost') ? 'abnormalBox' : 'box'">
            {{calculationResult.meatProductCost?.toFixed(2) || '-'}}
          </div>
        </a-col>
      </a-row>
    </div>
    </a-modal>
</template>

<script>
export default {
  props:['visible','calculationResult','calculationAbnormal'],
  data(){
    return{}
  },
  methods:{
    // 关闭弹窗并执行确认回调
    handleOk() {
      this.$emit('isShow', false)
      this.$emit('confirm')
    },
    // 关闭弹窗并将现有异常值清空
    handleCancel() {
      this.$emit('calculationAbnormalInit')
      this.$emit('isShow', false)
    },
    isAbnormal(value){
      return this.calculationAbnormal.includes(value)
    }
  }
}
</script>

<style lang='scss'>
.result{
  background-color:whitesmoke;
  padding: 3px;
  span{
    margin-left: 10px;
  }
  .box{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
  }
  .abnormalBox{
    background-color: white;
    padding: 5%;
    margin: 1px;
    width:100%;
    text-align: center;
    color: red;
  }
  .anticon{
    color: orange 
  }
}
</style>